import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import qs from 'qs'
import type { User } from 'src/dto'

export const contractBaseURL = `https://contract.${domainProvider.TARGET_DOMAIN}`
export const contractBaseURL_staging = `https://contract-staging.${domainProvider.TARGET_DOMAIN}`

export const B2G_CONTRACT_CONSULT_URL = 'https://u4wa3amsjw1.typeform.com/to/yct8RHzH'

export const getContractUrl = (user: User, urlWithParams?: string) => {
  if (!user.isAdmin) {
    return
  }

  let baseURL = contractBaseURL

  if (import.meta.env.VITE_VERCEL_ENV !== 'production') {
    baseURL = contractBaseURL_staging
  }

  if (urlWithParams) {
    const [originURL, params] = urlWithParams.split('?')

    return (
      originURL +
      qs.stringify(
        {
          ...qs.parse(params, { ignoreQueryPrefix: true }),
          classID: user?.academyId,
          loginID: user?.loginId,
        },
        { addQueryPrefix: true },
      )
    )
  }

  return `${baseURL}/?type=trial&classID=${user.academyId}&loginID=${user.loginId}`
}

export const getContractUrlWithPromotion = (user: User, promotionUrl?: string) => {
  if (!promotionUrl) {
    return getContractUrl(user)
  }

  let url = promotionUrl

  if (!url.startsWith('http')) {
    url = `https://${url}`
  }

  if (url.includes(`contract.${domainProvider.TARGET_DOMAIN}`)) {
    const contractUrl = getContractUrl(user, url)
    if (contractUrl) {
      url = contractUrl
    }
  }

  return url
}
